/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smart_Sleek_Nils_SmileInputs */

const fr_smart_sleek_nils_smile = /** @type {(inputs: Smart_Sleek_Nils_SmileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soir`)
};

/**

* @param {Smart_Sleek_Nils_SmileInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const smart_sleek_nils_smile = /** @type {((inputs?: Smart_Sleek_Nils_SmileInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smart_Sleek_Nils_SmileInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_smart_sleek_nils_smile(inputs)
});